module.exports = __webpack_public_path__ + "static/media/ex-kyc-icon1.30428118.svg";